import React from 'react';
import Sparkline from './Sparkline';
import { formatNumber, trendView, weekNumber } from './engagementHelpers';

/* Tab "Yritykset" (OVIO-110): figures of the latest complete week, 26-week active-user sparkline, trend. */

const BOLD = 'TitilliumWeb-SemiBold';
const num = { textAlign: 'right', whiteSpace: 'nowrap' };
const th = {
  fontSize: 13, fontWeight: 'normal', color: '#4A5560', padding: '10px 5px', borderBottom: '1px solid #E3E6EA',
  textAlign: 'left', verticalAlign: 'bottom', lineHeight: '16px',
};
const td = { fontSize: 15, color: '#222', padding: '0 5px', height: 50, borderBottom: '1px solid #E3E6EA' };
const TYPES = { organization: 'typeOrganization', workshop: 'typeWorkshop', chain: 'typeChain' };
const TILES = [
  ['login', 'tileLogin'], ['visit', 'tileVisit'], ['service_record_added', 'tileService'],
  ['message_sent', 'tileMessages'], ['erp_report_opened', 'tileErp'],
];
const COLUMNS = [
  ['login', 'colLogin'], ['visit', 'colVisit'], ['service_record_added', 'colService'],
  ['message_sent', 'colMessages'], ['erp_report_opened', 'colErp', 'erp'],
];

function Tile({ value, label }) {
  return (
    <div style={{ marginRight: 30 }}>
      <div style={{ fontSize: 26, fontFamily: 'TitilliumWeb-Bold', color: '#222', lineHeight: '34px' }}>{formatNumber(value)}</div>
      <div style={{ fontSize: 13, color: '#4A5560', whiteSpace: 'nowrap' }}>{label}</div>
    </div>
  );
}

export function Trend({ value }) {
  const view = trendView(value);
  return (
    <span style={{ color: view.color, fontFamily: view.arrow ? BOLD : 'inherit' }}>
      {view.arrow && <span style={{ marginRight: 4 }}>{view.arrow}</span>}
      {view.text}
    </span>
  );
}

export default function CompaniesTab({ data, t }) {
  const week = weekNumber(data.latest_week);
  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', margin: '26px 0 20px' }}>
        <Tile value={data.total.active_users} label={t('tileUsers', { week })} />
        {TILES.map(([key, label]) => <Tile key={key} value={data.total[key]} label={t(label)} />)}
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={th}>{t('colCompany')}</th>
              <th style={th}>{t('colType')}</th>
              <th style={th}>{t('colSeries')}</th>
              <th style={{ ...th, textAlign: 'right' }}>{t('colUsers', { week })}</th>
              {COLUMNS.map(([key, label]) => <th key={key} style={{ ...th, textAlign: 'right' }}>{t(label)}</th>)}
              <th style={{ ...th, textAlign: 'right' }}>{t('colTrend')}</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.length === 0 && (
              <tr><td style={{ ...td, color: '#5F6B76' }} colSpan={10}>{t('empty')}</td></tr>
            )}
            {data.rows.map(row => (
              <tr key={row.type + row.id}>
                <td style={td}>{row.name}</td>
                <td style={td}>{t(TYPES[row.type])}</td>
                <td style={td}><Sparkline values={row.series} weeks={data.weeks} label={row.name + ': ' + t('colSeries')} /></td>
                <td style={{ ...td, ...num }}>{formatNumber(row.latest.active_users)}</td>
                {COLUMNS.map(([key, , col]) => (
                  <td key={key} data-col={col || key} style={{ ...td, ...num, color: row.latest[key] === null ? '#9AA3AB' : '#222' }}>
                    {formatNumber(row.latest[key])}
                  </td>
                ))}
                <td style={{ ...td, ...num }}><Trend value={row.trend} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p style={{ fontSize: 13, color: '#5F6B76', lineHeight: '20px', marginTop: 24 }}>{t('help', { week })}</p>
    </div>
  );
}
